import { CSSProperties, FC, useCallback } from 'react';

import { matchPath, useNavigate, useParams } from 'react-router-dom';
import { AppBar, Box, IconButton, SxProps, Toolbar } from '@mui/material';

import { ReactComponent as Logo } from 'assets/images/headerLogo.svg';
import { ReactComponent as MenuIcon } from 'assets/icons/menuBurger.svg';
import { getDefaultUserRoute } from 'app/providers/utils';
import { CommonButton } from 'components';
import { useAuth } from 'hooks';
import { useAppDispatch } from 'state/hooks';
import { setSignupModal } from 'state/slices/account';
import { UnitsType } from 'app/api/quotes';
import { useQuery } from 'react-query';
import { getProductData } from 'app/api/products';
import { ROUTES } from 'app/routes/constants';

import { HeaderSearch } from '../../../HeaderSearch';
import { Notifications } from '../../../Notifications';
import { UserMenu } from '../../../UserMenu';
import { styles } from './styles';

interface MobileHeaderProps {
  isShadow: boolean;
  isActionsEnabled?: boolean;
  logoSx?: SxProps;
  minHeight?: CSSProperties['minHeight'];
  onMenuButtonClick?: () => void;
}

const RequestAccessLogin = () => {
  const dispatch = useAppDispatch();
  const isProductDetailsPage = matchPath(ROUTES.common.product, window.location.pathname);
  const { id } = useParams<{ id: string }>();
  const { data: productData } = useQuery(['company', id], () => getProductData(parseInt(id as string, 10)), {
    enabled: !!isProductDetailsPage,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const handleClick = () => {
    const metadata =
      isProductDetailsPage && productData
        ? {
            quantity: 0,
            units: UnitsType.KG,
            product: productData,
          }
        : {};

    dispatch(
      setSignupModal({
        isOpen: true,
        state: isProductDetailsPage ? 'requestAccess' : 'welcome',
        source: 'header',
        metadata,
      }),
    );
  };
  return (
    <CommonButton variant="contained" sx={styles.requestAccessBtn} onClick={handleClick}>
      Free Access
    </CommonButton>
  );
};

export const MobileHeader: FC<MobileHeaderProps> = ({
  isShadow,
  isActionsEnabled = true,
  logoSx,
  minHeight,
  onMenuButtonClick,
}) => {
  const navigate = useNavigate();
  const { isBuyer, activeUser } = useAuth();

  const handleRedirectHome = useCallback(() => {
    navigate(getDefaultUserRoute(isBuyer));
  }, [isBuyer, navigate]);
  const isBuyerOrNotActive = isBuyer || !activeUser;
  return (
    <AppBar position="fixed" sx={styles.mainWrap(isShadow, isBuyerOrNotActive, minHeight)}>
      <Toolbar sx={styles.toolBar(!isActionsEnabled)}>
        {isActionsEnabled && activeUser && (
          <Box sx={styles.leftSideWrap}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={onMenuButtonClick}
              sx={styles.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <Notifications />
          </Box>
        )}

        <Box sx={{ ...styles.logo, ...logoSx }}>
          <Logo onClick={handleRedirectHome} />
        </Box>

        {isActionsEnabled && activeUser && <UserMenu />}
        {!activeUser && <RequestAccessLogin />}
      </Toolbar>

      {isBuyerOrNotActive && isActionsEnabled && <HeaderSearch />}
    </AppBar>
  );
};
